import AssignWorker from "./components/AssignWorker";
import ManageWorkers from "./components/ManageWorkers";

const IssueWorker = ({ data, refetch }) => {
  if (!data?.issue_type) return null;
  if (data.issue_type === "master") {
    return <ManageWorkers data={data} refetch={refetch} />;
  }
  return <AssignWorker data={data} refetch={refetch} />;
};

export default IssueWorker;
